import axios from "@/utils/axios";
import {RuleMetadata} from "@/types/ruleTypes";

export async function createRule(rule : any) {
    const response = await axios.post(`rule/v2/rules`, rule);
    return response.data;
}

export async function getRulesMetadata(): Promise<RuleMetadata>{
    const response = await axios.get("rule/v2/metadata")
    return response.data;
}

export async function getRules() {
    const response = await axios.get(`rule/v2/rules`)
    return response.data;
}

export async function updateRule(rule : any) {
    const response = await axios.put(`rule/v2/rules/${rule.id}`, rule);
    return response.data;
}

export async function getRuleById(id: string | number) {
    const response = await axios.get(`rule/v2/rules/${id}`);
    return response.data;
}

export async function updateRuleToggle(id: string | number, enabled : boolean) {

    const payload = {
        id: id,
        enabled : enabled
    }

    const response = await axios.put(`rule/v2/rules/`, payload)
    return response.data
}

export async function deleteRule(id: string | number) {
    const response = await axios.delete(`rule/v2/rules`, {
        data: { id: id }
    });
    console.log(response)
    return response.data
}